<div fxLayout="row wrap">
  <div fxFlex="100">
    <mat-card>
      <mat-card-content>
        <div class="table-responsive">
          <div class="inline-table-row">
            <div class="filter-section">
              <div>
                <button *ngIf="!showSearch" mat-icon-button color="primary" (click)="showHideSearch()">
                  <mat-icon>search</mat-icon>
                </button>
                <div class="search" *ngIf="showSearch">
                  <mat-form-field class="search-box">
                    <mat-label>Search</mat-label>
                    <input matInput #detectorSearch [(ngModel)]="searchedText" placeholder="Search"
                      (keyup)="getDetectors()" />
                    <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              </div>
              <div class="filter-item">
                <mat-form-field class="example-full-width">
                  <mat-label>Detector Type</mat-label>
                  <mat-select placeholder="Detector Type" multiple [(ngModel)]="selectedDetectorTypes">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="detectorTypeSearch"
                        placeholderLabel="Search Detector Type..."
                        noEntriesFoundLabel="No matching Detector Type found">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngIf="filteredDetectorTypes.length > 0" #allDetectorTypeCheckbox
                      (click)="allSelection('detectorType')" [value]="-1">All
                    </mat-option>
                    <mat-option (click)="singleSelection('detectorType')"
                      *ngFor="let detectorType of filteredDetectorTypes" [value]="detectorType.id">
                      {{ detectorType.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="filter-item">
                <mat-form-field class="example-full-width">
                  <mat-label>Batch ID</mat-label>
                  <mat-select placeholder="Detector Type" multiple [(ngModel)]="selectedBatchIds">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="batchIdSearch" placeholderLabel="Search Batch ID..."
                        noEntriesFoundLabel="No matching Batch ID found">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngIf="filteredBatchIds.length > 0" #allBatchIdCheckbox
                      (click)="allSelection('batchId')" [value]="'-1'">All
                    </mat-option>
                    <mat-option (click)="singleSelection('batchId')" *ngFor="let batchId of filteredBatchIds"
                      [value]="batchId.batch_id">
                      {{ batchId.batch_id }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="filter-item">
                <mat-form-field class="example-full-width">
                  <mat-label>Slot ID</mat-label>
                  <mat-select placeholder="Detector Type" multiple [(ngModel)]="selectedSlotIds">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="slotIdSearch" placeholderLabel="Search Slot ID..."
                        noEntriesFoundLabel="No matching Slot ID found">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngIf="filteredSlotIds.length > 0" #allSlotIdCheckbox (click)="allSelection('slotId')"
                      [value]="'-1'">All
                    </mat-option>
                    <mat-option (click)="singleSelection('slotId')" *ngFor="let slotId of filteredSlotIds"
                      [value]="slotId.slot_id">
                      {{ slotId.slot_id }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="filter-item">
                <mat-form-field class="example-full-width">
                  <mat-label>Production Detector ID</mat-label>
                  <mat-select placeholder="Detector Type" multiple [(ngModel)]="selectedProdDetectorIds">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="prodDetectorIdSearch"
                        placeholderLabel="Search Production Detector ID..."
                        noEntriesFoundLabel="No matching Production Detector ID found">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngIf="filteredProdDetectorIds.length > 0" #allProdDetectorIdCheckbox
                      (click)="allSelection('prodDetectorId')" [value]="'-1'">All
                    </mat-option>
                    <mat-option (click)="singleSelection('prodDetectorId')"
                      *ngFor="let prodDetectorId of filteredProdDetectorIds"
                      [value]="prodDetectorId.production_detector_id">
                      {{ prodDetectorId.production_detector_id }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div (click)="picker.open()" class="filter-item">
                <mat-form-field class="example-full-width">
                  <mat-label>Select a date range</mat-label>
                  <mat-date-range-input (click)="picker.open()" [rangePicker]="picker" [max]="futureDate">
                    <input readonly [(ngModel)]="fromDate" matStartDate placeholder="From date">
                    <input readonly [(ngModel)]="toDate" matEndDate placeholder="To date"
                      (dateChange)="onDateRangeChange()">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
              </div>

              <!-- <div class="d-flex">
                <button *ngIf="!showSearch" mat-icon-button color="primary" class="m-l-10" (click)="showHideSearch()">
                  <mat-icon>search</mat-icon>
                </button>
                <button mat-raised-button color="primary" class="m-l-10" [disabled]="isFilterApplied()"
                  (click)="clearFilter()">
                  Clear Filters
                </button>

                <button mat-raised-button color="primary" class="m-l-10" (click)="openDialog('Add',{})">Add
                  Detector</button>
              </div> -->
            </div>
            <div class="d-flex">
              <button mat-raised-button color="primary" (click)="openDialog('Add',{})">Add
                Detector</button>
              <button mat-raised-button color="primary" class="m-l-10" [disabled]="isFilterApplied()"
                (click)="clearFilter()">
                Clear Filters
              </button>
            </div>

            <!-- <div class="search" *ngIf="showSearch">
              <mat-form-field class="search-box">
                <mat-label>Search</mat-label>
                <input matInput #detectorSearch [(ngModel)]="searchedText" placeholder="Search"
                  (keyup)="getDetectors()" />
                <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div> -->

            <div *ngIf='length !== 0' class="example-container ex-c-general">
              <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                [matSortActive]="orderOn" [matSortDirection]="orderBy" class="table employee-list no-wrap">

                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef> Index </th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{!!pageIndex ? (i+1) + (pageIndex*pageSize) : i+1}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="id">
                  <th disableClear mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
                  <td class="might-overflow" [matTooltip]="element.id" mat-cell *matCellDef="let element">
                    {{ element.id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="batch_id">
                  <th disableClear mat-header-cell *matHeaderCellDef mat-sort-header> Batch ID </th>
                  <td class="might-overflow" [matTooltip]="element.batch_id" mat-cell *matCellDef="let element">
                    {{ element.batch_id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="slot_id">
                  <th disableClear mat-header-cell *matHeaderCellDef mat-sort-header> Slot ID </th>
                  <td class="might-overflow" [matTooltip]="element.slot_id" mat-cell *matCellDef="let element">
                    {{ element.slot_id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="production_detector_id">
                  <th disableClear mat-header-cell *matHeaderCellDef mat-sort-header> Production Detector ID </th>
                  <td class="might-overflow" [matTooltip]="element.production_detector_id" mat-cell
                    *matCellDef="let element">
                    {{ element.production_detector_id }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="detector_type">
                  <th disableClear mat-header-cell *matHeaderCellDef mat-sort-header> Detector Type </th>
                  <td class="might-overflow" [matTooltip]="element.detector_type_name" mat-cell
                    *matCellDef="let element">
                    {{ element.detector_type_name }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th disableClear mat-header-cell *matHeaderCellDef mat-sort-header> Created At </th>
                  <td class="might-overflow" [matTooltip]="element.createdAt | date: 'dd MMM YYY, HH.mm.ss'" mat-cell
                    *matCellDef="let element"> {{ element.createdAt | date: 'dd MMM YYY, HH.mm.ss' }} </td>
                </ng-container>

                <ng-container matColumnDef="updatedAt">
                  <th disableClear mat-header-cell *matHeaderCellDef mat-sort-header> Last Updated At </th>
                  <td class="might-overflow" [matTooltip]="element.updatedAt | date: 'dd MMM YYY, HH.mm.ss'" mat-cell
                    *matCellDef="let element"> {{ element.updatedAt | date: 'dd MMM YYY, HH.mm.ss' }} </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef> Action </th>
                  <td mat-cell *matCellDef="let element" class="action-link">
                    <a [matTooltip]="tooltip.update_detector" [ngClass]="{'disabled': element.is_associated }"
                      (click)="openDialog('Update',element)" class="m-r-10 cursor-pointer"><i
                        class="fa fa-pencil editFont"></i></a>
                    <a [matTooltip]="tooltip.delete_detector"
                      [ngClass]="element.is_associated ? 'disabled' : 'text-danger'"
                      (click)="openDialog('Delete',element)" class="m-r-10 cursor-pointer">
                      <i class="fa fa-trash deleteFont"></i>
                    </a>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
            <div class="no-record" *ngIf='length === 0'> No record found </div>
          </div>
        </div>
        <mat-paginator #paginator [pageSizeOptions]="pageSizeOptions" [length]="length" [pageIndex]="pageIndex"
          [pageSize]="pageSize" showFirstLastButtons (page)="getDetectors($event)"></mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div class="overlay" *ngIf="isProcessing">
  <mat-spinner class="loader"></mat-spinner>
</div>